var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSparklesTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sparkles-two",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.96 37.96",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".sparkles-two--st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sparkle-sm",
    className: "sparkles-two--st0",
    d: "M24.14.87c2 2.79 4.76 4.94 7.95 6.21-2.79 2-4.94 4.76-6.21 7.95-2-2.79-4.76-4.94-7.95-6.21 2.78-2 4.94-4.76 6.21-7.95z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "sparkle-lg",
    className: "sparkles-two--st0",
    d: "M10.01 16.71c2.83 3.94 6.73 6.99 11.24 8.78a25.363 25.363 0 00-8.78 11.24 25.363 25.363 0 00-11.24-8.78c3.94-2.83 6.99-6.73 8.78-11.24z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklesTwo);
export default __webpack_public_path__ + "static/media/sparkles-two.52bddaeddee61d8353d7af5c4ac48a35.svg";
export { ForwardRef as ReactComponent };